module.exports = __webpack_public_path__ + "img/zx3.e739c3d7.png";